import { useEffect, useState, createContext, useContext } from "react";
import { api } from "@/lib/api";

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/site-settings");
      setSettings(data.settings || {});
    } catch {
      setSettings({});
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loaded, refresh, setSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
